var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"messages"},[_c('el-container',[_c('el-aside',{attrs:{"width":"18%"}},[_c('sidebar')],1),_c('el-container',[_c('Header'),_c('el-main',[_c('Form',{attrs:{"type":"0"}})],1),_c('el-footer',[_c('Footer')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }